import Phaser from 'phaser';
import { WORLD } from './config/constants';
import { app } from './app';
import { Game } from './core/Game';
import { loadMarketSnapshot } from './core/Market';
import { UI } from './ui/UI';
import { WorldScene } from './world/WorldScene';
import './ui/theme.css';
import './ui/progression.css';

async function boot(): Promise<void> {
  const snapshot = await loadMarketSnapshot();
  const game = new Game(snapshot);
  app.game = game;
  const ui = new UI(game);
  app.ui = ui;

  new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game',
    width: WORLD.WIDTH,
    height: WORLD.HEIGHT,
    backgroundColor: '#1d1b2a',
    transparent: true,
    scale: { mode: Phaser.Scale.RESIZE, autoCenter: Phaser.Scale.CENTER_BOTH },
    scene: [WorldScene],
    render: { antialias: true, pixelArt: false },
  });

  window.addEventListener('beforeunload', () => game.save());
  if (import.meta.env.DEV) {
    // Debug handle for the console: cheese.game.state, cheese.game.advanceMinutes(30), cheese.ui.openObject('vat')
    (window as unknown as { cheese: typeof app }).cheese = app;
  }
  if (new URLSearchParams(window.location.search).get('dev') === '1' && !game.devMode) game.enableDevMode();
  if (game.state.stats.daysPlayed === 0 && game.state.xp.total === 0) {
    game.toast('Welcome to the farm. Click Bessie to feed and milk her.', 'info');
  } else {
    game.toast(`Welcome back. Day ${game.state.day}.`, 'info');
  }
  game.toast('Version 1G · Walk freely and explore your farm.', 'info');
}

void boot();
